import { ConfirmDialogs } from "../components/ConfirmDialogs.js";
import { DetailSheet } from "../components/DetailSheet.js";
import { PhaseTutorial } from "../components/PhaseTutorial.js";
import { StatHelpDialog } from "../features/case/StatHelpDialog.js";
import { CasePlayScreen } from "../features/case/CasePlayScreen.js";
import { CaseResolveScreen } from "../features/case/CaseResolveScreen.js";
import { MapScreen } from "../features/map/MapScreen.js";
import { RestScreen } from "../features/rest/RestScreen.js";
import { ResultScreen } from "../features/result/ResultScreen.js";
import { ResultExitProvider } from "../features/result/ResultExitContext.js";
import type { ResultExit } from "../features/result/resultExit.js";
import { RewardCardScreen } from "../features/reward/RewardCardScreen.js";
import { RewardOrgScreen } from "../features/reward/RewardOrgScreen.js";
import { StageSelectScreen } from "../features/title/StageSelectScreen.js";
import { BringInScreen } from "../features/bringIn/BringInScreen.js";
import { PatchNotesDialog } from "../features/title/PatchNotesDialog.js";
import { TitleScreen } from "../features/title/TitleScreen.js";
import { EventScreen } from "../features/event/EventScreen.js";
import { useGame } from "./GameProvider.js";

function ScreenRouter() {
  const { state } = useGame();
  switch (state.screen) {
    case "title":
      return <TitleScreen />;
    case "stageSelect":
      return <StageSelectScreen />;
    case "bringIn":
      return <BringInScreen />;
    case "map":
      return <MapScreen />;
    case "case.play":
      return <CasePlayScreen />;
    case "case.resolve":
      return <CaseResolveScreen />;
    case "reward.card":
      return <RewardCardScreen />;
    case "reward.organization":
      return <RewardOrgScreen />;
    case "rest":
      return <RestScreen />;
    case "event":
      return <EventScreen />;
    case "result.clear":
    case "result.gameover":
      return <ResultScreen />;
    default:
      return <TitleScreen />;
  }
}

export function GameChrome({ resultExit }: { resultExit?: ResultExit } = {}) {
  return (
    <ResultExitProvider value={resultExit}>
      <div className="stage">
        <div className="device">
          <ScreenRouter />
          <DetailSheet />
          <PatchNotesDialog />
          <ConfirmDialogs />
          <PhaseTutorial />
          <StatHelpDialog />
        </div>
      </div>
    </ResultExitProvider>
  );
}
